<template>
    <el-row class="warp">
        <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
            <!--工具条-->
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
                <el-form :inline="true">
                    <el-form-item>
                        <el-button type="primary" @click="search()">刷新</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="add()">增加</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--列表-->
            <el-table :data="pros" highlight-current-row v-loading="loading" border style="width: 100%">
                <el-table-column label="序号" type="index" :index="indexMethod"></el-table-column>
                <el-table-column label="专题图片" prop="imgurl">
                    <template slot-scope="scope">
                        <div class="demo-image__preview">
                            <el-image style="width: 60px; height: 40px" :src="scope.row.imgurl">
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="专题页ID" prop="id"></el-table-column>
                <el-table-column label="备注" prop="content"></el-table-column>
                <el-table-column label="更新时间" prop="updatetime" width="180" :formatter="formatTime"></el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="edit(scope.$index, scope.row)">修改</el-button>
                        <el-button type="text" @click="del(scope.row)">删除</el-button>
                        <el-button type="text" @click="goods(scope.row)">商品关联</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-col :span="24" class="toolbar">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="page" :page-sizes="[10, 20, 50]" :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </el-col>
            <!-- 修改页面 -->
            <el-dialog title="编辑" :visible.sync="editFormVisible" center :close-on-click-modal="false" @close="resetForm('editForm')">
                <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
                    <el-form-item label="专题图片" prop="imgurl">
                        <el-upload class="avatar-uploader" action="/mallapi/MallApi/file/upload" :show-file-list="false"
                            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                            <img v-if="editForm.imgurl" :src="editForm.imgurl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <div class="el-upload__tip" slot="tip" style="font-weight: bold">图片只能是 JPG
                                格式，且不超过2M
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-row :gutter="10">
                        <el-col :span="10">
                            <el-form-item label="备注" prop="content">
                                <el-input type="textarea" v-model="editForm.content"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="editFormVisible = false">取消</el-button>
                    <el-button type="primary" @click.native="submit" :loading="addLoading">提交</el-button>
                </div>
            </el-dialog>
            <!-- 商品列表 -->
            <el-dialog title="商品列表" :visible.sync="redlogFormVisible" :close-on-click-modal="false">
                <!--列表-->
                <el-table :data="redLog" highlight-current-row v-loading="loading" style="width: 100%">
                    <el-table-column label="序号" type="index"> </el-table-column>
                    <el-table-column prop="goodsid" label="商品ID"> </el-table-column>
                    <el-table-column prop="name" label="商品名称"> </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                        <template slot-scope="scope">
                            <el-button type="text" @click="opendel(scope.row)">移除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="total, prev, pager, next" @current-change="handleredCurrentChange"
                        :page-size="10" :total="totalred" style="float: right">
                    </el-pagination>
                </el-col>
            </el-dialog>

        </el-col>
    </el-row>
</template>
<script>
import MallApi from "../../../api/goods/promotionapi"
import moment from 'moment'
export default {
    data() {
        return {

            redlogFormVisible: false,
            redLog: [],
            totalred: 0,
            pagered: 1,
            limitred: 10,
            pagelog: 1,

            formData: {},



            loading: false,
            total: 0,
            page: 1,
            limit: 10,
            pros: [],

            editFormVisible: false,
            editForm: {
                brandid: '',
                imgurl: '',
                detaillink: ''
            },
            editFormRules: {
                brandid: [{ required: true, message: "请选择品牌", trigger: "change" }],
                imgurl: [{ required: true, message: "请上传轮播图片", trigger: "blur" }],
                //detaillink: [{ required: true, message: "请输入链接商品ID", trigger: "blur" }],
            },
            dialogVisible: false,
            //提交按钮状态
            addLoading: false,
        };

    },
    methods: {
        indexMethod(index) {
            return (index + 1) + (this.page - 1) * (this.limit)
        },
        formatTime(row, column) {
            let date = row[column.property];
            if (date === undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        handleCurrentChange(val) {
            this.page = val;
            this.search();
        },
        handleSizeChange(val) {
            this.limit = val;
            this.search();
        },
        handleSearch() {
            this.total = 0;
            this.page = 1;
            this.search();
        },
        search: function () {
            let params = {
                pageNum: this.page,
                pageSize: this.limit,
            };

            this.loading = true

            let that = this
            MallApi.list(params)
                .then(
                    function (result) {
                        that.loading = false;
                        if (result && result.data.totalSize) {
                            that.total = result.data.totalSize;
                            that.pros = result.data.content;
                        } else {
                            that.total = 0;
                            that.pros = null;
                        }
                    },
                    function (err) {
                        that.loading = false;
                        that.$message.error({
                            showClose: true,
                            message: err.toString(),
                            duration: 2000,
                        });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                        showClose: true,
                        message: "请求出现异常",
                        duration: 2000,
                    });
                });
        },

        //页面
        add: function (index, row) {
            this.editFormVisible = true;
            this.editForm = {}
        },
        edit: function (index, row) {
            this.editFormVisible = true;
            this.editForm = Object.assign({}, row)
        },
        //保存
        submit: function () {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let that = this;
                    this.addLoading = true;
                    MallApi.save(this.editForm).then(function (result) {
                        if (0 === result.code) {
                            that.addLoading = false;
                            that.$message;
                            that.$message.success({
                                showClose: true,
                                message: "操作成功",
                                duration: 2000,
                            });
                            that.$refs["editForm"].resetFields();
                            that.editFormVisible = false;
                            that.search();
                        } else {
                            that.$message.error({

                                showClose: true,
                                message: result.message || "操作失败",
                                duration: 2000,
                            });
                            that.addLoading = false;
                        }
                    });
                } 
            })
        },

        del(e) {
            let that = this;
            this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
                .then(() => {
                    that.loading = true;
                    MallApi.delete({ id: e.id })
                        .then(
                            function (result) {
                                that.loading = false;
                                if (result && parseInt(result.code) === 0) {
                                    that.$message.success({
                                        showClose: true,
                                        message: "删除成功",
                                        duration: 1500,
                                    });
                                    that.search();
                                } else {
                                    that.$message.error({
                                        showClose: true,
                                        message: result.message,
                                        duration: 1500,
                                    });
                                }
                            },
                            function (err) {
                                that.loading = false;
                                that.$message.error({
                                    showClose: true,
                                    message: err.toString(),
                                    duration: 2000,
                                });
                            }
                        )
                        .catch(function (error) {
                            that.loading = false;
                            console.log(error);
                            that.$message.error({
                                showClose: true,
                                message: "请求出现异常",
                                duration: 2000,
                            });
                        });
                })
                .catch(() => { });
        },


        //缩略图上传
        handleAvatarSuccess(res) {
            if (res.code === 0) {
                this.editForm.imgurl = "data:image/jpeg;base64," + res.data
                this.$forceUpdate() //强制渲染
            } else {
                this.$message.error(res.message)
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        goods(e) {
            this.redLog = []
            this.redlogFormVisible = true
            this.formData = e
            this.searchRed();
        },
        //商品列表 分页跳转
        handleredCurrentChange(val) {
            this.pagelog = val;
            this.searchRed();
        },
        //兑换记录 分页
        searchRed() {
            let params = {
                pageNum: this.pagelog,
                pageSize: 10,
                proId: this.formData.id,
            };
            let that = this;
            MallApi.listpage(params)
                .then(
                    function (result) {
                        if (0 === result.code) {
                            that.redlogFormVisible = true;
                            that.totalred = result.data.totalSize;
                            that.redLog = result.data.content;
                        }
                    },
                    function (err) {
                        that.loading = false;
                        that.$message.error({
                            showClose: true,
                            message: err.toString(),
                            duration: 2000,
                        });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: "请求出现异常",
                        duration: 2000,
                    });
                });
        },

        opendel(e) {
            let that = this;
            this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
                .then(() => {
                    that.loading = true;
                    MallApi.deletegoods({ id: e.id })
                        .then(
                            function (result) {
                                that.loading = false;
                                if (result && parseInt(result.code) === 0) {
                                    that.$message.success({
                                        showClose: true,
                                        message: "删除成功",
                                        duration: 1500,
                                    });
                                    that.searchRed();
                                } else {
                                    that.$message.error({
                                        showClose: true,
                                        message: result.message,
                                        duration: 1500,
                                    });
                                }
                            },
                            function (err) {
                                that.loading = false;
                                that.$message.error({
                                    showClose: true,
                                    message: err.toString(),
                                    duration: 2000,
                                });
                            }
                        )
                        .catch(function (error) {
                            that.loading = false;
                            console.log(error);
                            that.$message.error({
                                showClose: true,
                                message: "请求出现异常",
                                duration: 2000,
                            });
                        });
                })
                .catch(() => { });
        },


    },
    mounted() {
        this.handleSearch()
    },
};
</script>

<style scoped>

</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
